import React from 'react'

const ProductDetailView = (props) => {
  return (
    <div>
        <p>Item Name : {props.data.title}</p>
        <p>Item Buy Price : {props.data.buyPrice} {props.data.buyCurrency}</p>
        <p>Item Sales Price : Local ({props.data.sellPriceLocal} {props.data.sellLocalCurrency}) Foreign ({props.data.sellPriceForeigners} {props.data.sellForeignersCurrency}) </p>
        <p>Item Dimension : {props.data.dimension}</p>
        <p>Item Weight : {props.data.weight}</p>
    </div>
  )
}

export default ProductDetailView